import React from 'react';
import { Alert } from 'antd';
import type { RouteViewModelCorrection } from '../../../types/routeViewModel';

type Props = {
  advisories: RouteViewModelCorrection['advisories'];
};

/** Neutral advisory copy only — no penalty pre-selection or alarmist wording. */
export function PenaltyAdvisoryBanner({ advisories }: Props) {
  const penaltyAdvisory = advisories.find((a) => a.code === 'PENALTY_AT_COMPLETION');
  if (!penaltyAdvisory) return null;

  return (
    <Alert
      type="info"
      showIcon
      message="Информация о штрафах"
      description={penaltyAdvisory.message}
    />
  );
}
